const designer = {
  title: ({ brandName }) => `${brandName} | italist, ALWAYS LIKE A SALE`,
  description: ({ brandName, currentSeasonFull }) =>
    `Shop the largest selection of ${brandName} from the ${currentSeasonFull} collection. EXPRESS international shipping!`,
};

export default designer;
